import UIListener from '@/UIListener/UIListener';
import ListViewViewModel from '@/ViewModels/Views/ListViewViewModel';
import * as CoreFrameDTOs from "coreframetypings/dto";
import ComponentManager from '@/Management/ComponentManager';
import UIListenerHelper from '@/UIListener/UIListenerHelper';
import CustomFilterChipBuilder from '@/Utility/CustomFilterChipBuilder';
import ResourceManager from '@/Management/ResourceManager';
import * as DateHelper from '@/Utility/DateHelper';

export default class JournalEntryUIListener extends UIListener {

    constructor() {
        super();
    }

    public onBeforeListViewRender(context: ListViewViewModel, dto: CoreFrameDTOs.IListViewDTO) {
        const customFilterChip = new CustomFilterChipBuilder(ResourceManager.getInstance().get('CUSTOM_FILTER_RECENT_YEAR_DISPLAYNAME'))
            .useFilterStatement(this.createDateFilterStatement())
            .isActiveOnOpen(true)
            .build();

        context.appendCustomFilterChip(customFilterChip);
    }

    private createDateFilterStatement(): string {
        const currentDate = new Date();
        const pastDate = new Date();
        pastDate.setDate(currentDate.getDate() - 365);

        return DateHelper.createDateFilter("ChangeDate", pastDate, ">=");
    }
}

ComponentManager.setUIListener('JournalEntryUIListener', JournalEntryUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.JournalEntryUIListener', JournalEntryUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');